function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "money-off",
  d: "M18.647,8.6a8.337,8.337,0,0,0-3.315.622L12.017,6.009a13.654,13.654,0,0,1,3.315-1.243V0h6.63V4.869A9.141,9.141,0,0,1,27.09,7.977a9.311,9.311,0,0,1,2.02,5.283H24.137Q23.929,8.6,18.647,8.6ZM2.8,2.382,35.117,34.7l-2.8,2.8-4.972-4.972a10.3,10.3,0,0,1-5.387,2.486v4.766h-6.63V35.014a11.507,11.507,0,0,1-5.7-2.9,7.738,7.738,0,0,1-2.382-5.595h4.766q.518,4.662,6.63,4.662,3.937,0,5.387-2.072l-7.769-7.666q-8.7-2.59-8.7-8.7L0,5.18Z",
  fill: "#ac1ede"
});

var SvgMoneyOff = function SvgMoneyOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.117,
    height: 39.779,
    viewBox: "0 0 35.117 39.779",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoneyOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money-off.cc3fbf49.svg";
export { ForwardRef as ReactComponent };